import * as React from 'react';
import { BaseSvg, SVGIconProps } from './BaseSvg';

export const Dot: React.SFC<SVGIconProps> = ({ size = 5, color = '#71797D', ...props }) => (
  <BaseSvg width={size} height={size} viewBox="0 0 5 5" fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
    <circle cx="2.60742" cy="2.5" r="2" fill="#71797D" />
  </BaseSvg>
);
